import React from 'react'
import { Progress } from 'antd';
import { ProgressCompVar } from '../../Utils/variables';
import { validText } from '../../Helpers/helpers';

const { percent_sign } = ProgressCompVar;


const ProgressComp = ({ percent, text }) => {

    let validPercent = (percent) => Math.floor(Math.round(percent)) > 100 ? 100 : percent
    return (
        <div>
            <div className='dflex alignCenter justifySB'><p style={{ fontSize: "13px", textTransform:"capitalize" }}>{validText(text)}</p><span style={{ fontSize: "13px", color: "#1E6EFE", fontWeight: "bold" }}>{validPercent(percent)} {percent_sign}</span>
            </div>
            <Progress percent={validPercent(percent)} className="InputYeildP" trailColor="#CDD2DE" format={(percent) => ''} />
        </div>
    )
}

export default ProgressComp